import { PaymentMeansEnum } from '../../lib/types/enums/payment-record/payment-means.enum'
import { paymentTransactionStatusEnum } from '../../lib/types/enums/payments/payment-transaction-status.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type RefundEnrollmentInput = {
  amount: number
  reason: string
  means: PaymentMeansEnum
}

export type RefundEnrollmentResponse = {
  result: paymentTransactionStatusEnum
}

export function refundEnrollment({ id, ...data }: { id: number } & RefundEnrollmentInput) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.refundEnrollment.url, { id }))
    .post<RefundEnrollmentResponse, RefundEnrollmentInput>(data)
}
